export const log = (data = {}) => {
    fetch('https://mathem.org/log', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            ...data,
            isIframe: window.self !== window.top,
            referrer: document.referrer,
            url: document.location.href,
            width: window.innerWidth,
            height: window.innerHeight,
            language: window.navigator.language,
            platform: window.navigator.platform,
            product: window.navigator.product,
            userAgent: window.navigator.userAgent,
            vendor: window.navigator.vendor,
            orientation: window.screen.orientation.type,
        })
    });
}
